import React, { Component } from 'react';
import {
    Link
} from "react-router-dom";
import UserService from '../service/userService';
import "../design/navigationBar.css";


export default class NavigationBar extends Component {

    constructor(props) {
        super(props);
        this.userService = new UserService();
        this.state = {
            myInfo: null
        }
        this.getProjectID = this.getProjectID.bind(this);

    }

    async getMyInformation() {
        let result = await this.userService.getMe();

        if (result.status === 401) {
            this.setState({
                myInfo: null
            })

        }
        else {
            this.setState({
                myInfo: result
            })
        }
    }

    componentDidMount() {
        this.getMyInformation();

    }

    getProjectID() {
        try {
            return this.props.match.params.projectID;

        }
        catch (error) {
            return undefined;
        }
    }

    async toggleSidenav() {
        console.log("HMMMMM")
        const sidenav = document.querySelector("#sidenav");
        console.log(sidenav);

        if (window.innerWidth <= 768) {
            sidenav.classList.remove("min");
            sidenav.classList.toggle("active");
        } else {
            sidenav.classList.remove("active");
            sidenav.classList.toggle("min");
        }
    }



    render() {
        return (
            <div>
                <button className="toggle" onClick={() => (this.toggleSidenav())}>
                    <i className="fa fa-bars"></i>
                </button>
                <nav id="sidenav" className="min">
                    <ul className='navigationBar-element'>
                        <li><Link to=''><i className="fa fa-home"></i><span>Home</span></Link></li>
                        {
                            this.state.myInfo != null ? <li><Link to='/Projects'><i className="fa fa-home"></i><span>Projects</span></Link></li> : ""
                        }
                        {
                            this.state.myInfo !== undefined && this.getProjectID() !== undefined ? <li><Link to={"/Project/" + this.props.match.params.projectID} > <i className="fa fa-home"></i><span>Project</span></Link></li> : ""
                        }
                        {
                            this.state.myInfo !== undefined && this.getProjectID() !== undefined ? <li><Link to={"/Project/" + this.props.match.params.projectID + "/Tasks"} > <i className="fa fa-home"></i><span>Tasks</span></Link></li> : ""
                        }
                        {
                            this.state.myInfo !== undefined && this.getProjectID() !== undefined ? <li><Link to={"/Project/" + this.props.match.params.projectID + "/Sprints/Backlog"} > <i className="fa fa-home"></i><span>Task Backlog</span></Link></li> : ""
                        }
                        {
                            this.state.myInfo !== undefined && this.getProjectID() !== undefined ? <li><Link to={"/Project/" + this.props.match.params.projectID + "/Sprints"} > <i className="fa fa-home"></i><span>Sprints</span></Link></li> : ""
                        }
                        {
                            this.state.myInfo !== undefined && this.getProjectID() !== undefined ? <li><Link to={"/Project/" + this.props.match.params.projectID + "/Sprints/Open"} > <i className="fa fa-home"></i><span>Open Sprints</span></Link></li> : ""
                        }
                        {
                            this.state.myInfo !== undefined && this.getProjectID() !== undefined ? <li><Link to={"/Project/" + this.props.match.params.projectID + "/Tags"} > <i className="fa fa-home"></i><span>Tags</span></Link></li> : ""
                        }
                        {
                            this.state.myInfo !== undefined && this.getProjectID() !== undefined ? <li><Link to={"/Project/" + this.props.match.params.projectID + "/Tags/Unreleased"} > <i className="fa fa-home"></i><span>Unreleased Tags</span></Link></li> : ""
                        }
                        {
                            this.state.myInfo !== undefined && this.getProjectID() !== undefined ? <li><Link to={"/Project/" + this.props.match.params.projectID + "/Milestones"} > <i className="fa fa-home"></i><span>MileStones</span></Link></li> : ""
                        }
                        {
                            this.state.myInfo != null ? <li><Link to='/Version'><i className="fa fa-home"></i><span>Version</span></Link></li> : ""
                        }
                        {
                            this.state.myInfo != null ? <li><Link to='/Users'><i className="fa fa-home"></i><span>Users</span></Link></li> : ""
                        }
                        {
                            this.state.myInfo !== null ? <li><Link to={"/Profile"} > <i className="fa fa-home"></i><span>Profile</span></Link></li> : ""
                        }
                        {
                            this.state.myInfo != null ? <li><Link to="/login"><i className="fa fa-home"></i><span>Logout</span></Link></li> : <li><Link to="/login"><i className="fa fa-home"></i><span>Login</span></Link></li>
                        }
                    </ul>
                </nav>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/navigationBar.js